import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  signInWithPopup,
  GoogleAuthProvider,
  updateProfile,
  RecaptchaVerifier,
  linkWithPhoneNumber,
  signInWithPhoneNumber,
  sendPasswordResetEmail, // 👈 1. Added import
} from "firebase/auth";
import { auth } from "../config/firebase";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5172/api";
const googleProvider = new GoogleAuthProvider();

export const authService = {
  // 1. Backend Sync Function
  syncUserWithBackend: async (user, additionalData = {}) => {
    if (!user) return;
    try {
      const token = await user.getIdToken(true);
      const response = await axios.post(
        `${API_URL}/auth/sync`,
        additionalData,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Backend Sync Failed:", error);
      throw error;
    }
  },

  // 2. Setup Invisible Recaptcha for OTP
  setupRecaptcha: async (containerId) => {
    // ✅ If already exists, reuse it
    if (window.recaptchaVerifier) {
      return window.recaptchaVerifier;
    }

    window.recaptchaVerifier = new RecaptchaVerifier(auth, containerId, {
      size: "normal", // 👈 Changed from "invisible" to "normal" for the checkbox widget
    });

    await window.recaptchaVerifier.render();

    return window.recaptchaVerifier;
  },

  // 3. Link Phone to Existing Account (Used after Google Login)
  linkPhoneOtp: async (phoneNumber) => {
    const appVerifier = window.recaptchaVerifier;
    return await linkWithPhoneNumber(
      auth.currentUser,
      phoneNumber,
      appVerifier,
    );
  },

  // 3b. Direct Login with Phone Number
  sendLoginOtp: async (phoneNumber) => {
    const appVerifier = window.recaptchaVerifier;
    return await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
  },

  // 4. Standard Login
  login: async (email, password) => {
    const { user } = await signInWithEmailAndPassword(auth, email, password);
    return await authService.syncUserWithBackend(user);
  },

  // 5. Standard Register
  register: async (firstName, lastName, phone, email, password) => {
    const { user } = await createUserWithEmailAndPassword(
      auth,
      email,
      password,
    );
    try {
      await updateProfile(user, { displayName: `${firstName} ${lastName}` });
    } catch (e) {
      /* ignore */
    }
    return await authService.syncUserWithBackend(user, {
      firstName,
      lastName,
      phone,
    });
  },

  // 8. Get Current User Token (👈 ADD THIS)
  getToken: async () => {
    const user = auth.currentUser;
    if (user) {
      // Force refresh the token to ensure it's not expired
      return await user.getIdToken(true);
    }
    return null;
  },
  // 6. Google Login
  loginWithGoogle: async () => {
    const { user } = await signInWithPopup(auth, googleProvider);
    return await authService.syncUserWithBackend(user);
  },

  // 7. Password Reset / Forgot Password  👈 2. Added Method
  resetPassword: async (email) => {
    return await sendPasswordResetEmail(auth, email);
  },

  logout: async () => await signOut(auth),
};
